export const disclosures = [
    'Approved Seniors Project',
    'Corporate Listing',
    'Corporate Owned',
    'Exclusions',
    'Familial Relation',
    'Home Protection Plan',
    'Lead Base Paint Addendum',
    'Mi/Lenders Approval',
    'Municipal Utility District (MUD)',
    'Other Disclosures',
    'Other KS Listings Owned',
    'Owner/Agent',
    'Planned Unit Development',
    'Prospects Reserved',
    'Public Improvement District',
    'KS Listings Owned (Lender)',
    'Relo Addendum Required',
    'Rental Records Available',
    'Residential Service Contract',
    'Right of First Refusal (ROFR)',
    'Seller Disclosure',
    'Seller Provided Survey Available',
    'Special Addendum',
    'Warranty/See Remarks',
    'Water District',
    'None',
    'See Remarks'
];

export const documentsAvailable = [
    'Aerial Photos',
    'ALTA Survey',
    'APOD/Backup Available',
    'Appraisal',
    'Archeological Site',
    'Building Plans',
    'Condo Docs Available',
    'Cost Estimates',
    'Deed Restrictions',
    'Development Plan',
    'ECRA Clearance',
    'Energy Conservation Audit Disclosure',
    'Energy, Environment and Sustainability',
    'Engineering Report',
    'Environmental Study',
    'Environmental Study Complete',
    'Feasibility Study',
    'Financial Statement',
    'Financing',
    'Flowage Easement',
    'Geological',
    'Historical',
    'Income & Expense Statement',
    'Leases',
    'Legal Documents',
    'Municipal Utility District (MUD)',
    'Oak Wilt Test',
    'Off-Site Requirements',
    'Profit & Loss Statement',
    'Perc Test Needed',
    'Perc Test Results/Map',
    'Public Improvement District',
    'Rent Roll',
    'Schedule of Personal Property',
    'Security Codes',
    'Septic Certification',
    'Site Plan',
    'Soil Test',
    'Special Assessment District',
    'Standard Industrial Classification',
    'Survey',
    'Tax Return Available',
    'Topography Map',
    'Unit Mix Schedule',
    'Utility Easement',
    'Vendor Leases',
    'Water Capacity/Quality Report',
    'Water/Well Report',
    'Water/Well Test',
    'Wetlands Approval/Waiver',
    'Wetlands Delineation Map',
    'None Available',
    'See Remarks'
];

export const heating = [
    'Active Solar',
    'Baseboard',
    'Ceiling',
    'Central',
    'Coal',
    'Coal Stove',
    'Ductless',
    'Electric',
    'ENERGY STAR Qualified Equipment',
    'ENERGY STAR/ACCA RSI Quality Install',
    'Exhaust Fan',
    'Fireplace Insert',
    'Fireplace(s)',
    'Floor Furnace',
    'Forced Air',
    'Gravity',
    'Heat Pump',
    'Hot Water',
    'Humidity Control',
    'Kerosene',
    'Natural Gas',
    'Oil',
    'Passive Solar',
    'Pellet Stove',
    'Propane',
    'Propane Stove',
    'Radiant',
    'Radiant Ceiling',
    'Radiant Floor',
    'Separate Meters',
    'Space Heater',
    'Steam',
    'Varies by Unit',
    'Wall Furnace',
    'Wood',
    'Wood Stove',
    'Zoned',
    'None',
    'See Remarks'
];

export const cooling = [
    'Attic Fan',
    'Ceiling Fan(s)',
    'Central Air',
    'Dual',
    'Ductless',
    'Electric',
    'ENERGY STAR Qualified Equipment',
    'Exhaust Fan',
    'Gas',
    'Heat Pump',
    'Humidity Control',
    'Multi Units',
    'Roof Turbine(s)',
    'Separate Meters',
    'Varies by Unit',
    'Wall/Window Unit(s)',
    'Whole House Fan',
    'Zoned',
    'None',
    'See Remarks'
];

export const waterSource = [
    'Cistern',
    'Municipal Utility District (MUD)',
    'Private',
    'Public',
    'Shared Well',
    'Spring',
    'Well',
    'None',
    'See Remarks'
];

export const sewer = [
    'Aerobic Septic',
    'Cesspool',
    'Engineered Septic',
    'Holding Tank',
    'Mound Septic',
    'Municipal Utility District (MUD)',
    'Perc Test On File',
    'Perc Test Required',
    'Private Sewer',
    'Public Sewer',
    'Septic Needed',
    'Septic Shared',
    'Septic Tank',
    'None',
    'See Remarks'
];

export const utilitiesList = [
    'Above Ground',
    'Cable Available',
    'Cable Connected',
    'Cable Not Available',
    'Electricity Available',
    'Electricity Connected',
    'Electricity Not Available',
    'Internet-Cable',
    'Internet-Fiber',
    'Internet-Satellite/Other',
    'Natural Gas Available',
    'Natural Gas Connected',
    'Natural Gas Not Available',
    'None Available',
    'Phone Available',
    'Phone Connected',
    'Phone Not Available',
    'Propane',
    'Propane Needed',
    'Sewer Available',
    'Sewer Connected',
    'Sewer Not Available',
    'Solar',
    'Underground Utilities',
    'Water Available',
    'Water Connected',
    'Water Not Available',
    'Wind',
    'None',
    'See Remarks'
];

export const ownerPaysList = [
    'All Utilities',
    'Association Fees',
    'Cable TV',
    'Common Area Maintenance',
    'Electricity',
    'Exterior Maintenance',
    'Gas',
    'Grounds Care',
    'Hot Water',
    'HVAC Maintenance',
    'Insurance',
    'Internet',
    'Janitorial Service',
    'Management',
    'Parking Fee',
    'Pest Control',
    'Pool Maintenance',
    'Repairs',
    'Roof Maintenance',
    'Security',
    'Sewer',
    'Taxes',
    'Telephone',
    'Trash Collection',
    'Water',
    'None',
    'See Remarks'
];

export const meterDescription = [
    'Allocation Billing',
    'Electric Common',
    'Electric Separate',
    'Gas Common',
    'Gas Separate',
    'Read Meter',
    'Water Common',
    'Water Separate',
    'See Remarks'
];

export const tenantPays = [
    'All Utilities',
    'Association Fees',
    'Cable TV',
    'Common Area Maintenance',
    'Electricity',
    'Exterior Maintenance',
    'Gas',
    'Grounds Care',
    'Hot Water',
    'HVAC Maintenance',
    'Insurance',
    'Internet',
    'Janitorial Service',
    'Management',
    'Parking Fee',
    'Pest Control',
    'Pool Maintenance',
    'Repairs',
    'Security',
    'Sewer',
    'Telephone',
    'Trash Collection',
    'Water',
    'None',
    'See Remarks'
];
